import './Iskcon.scss';
import InnerNav from '../../../components/InnerNav/InnerNav';
import { useEffect, useState } from 'react';

import BengaliCalendar from '../../../components/BengaliCalender/BengaliCalender';

// import CommentBox from '../../../components/CommentBox/CommentBox';
import Footer from '../../../components/Footer/Footer';
import PanchangLinks from '../../../components/PanchangLinks/PanchangLinks';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import axios from 'axios';
import IsckonCal from '../../../components/IsconCal/IsckonCal';

const Iskcon = () => {
  
  const [timeFormat, setTimeFormat] = useState('12');
  const [monthly, setMonthly] = useState(null);

const [iskconFestivals, setIskconFestivals] = useState([]);
const [monthName, setMonthName] = useState('');

 const year = new Date().getFullYear();
  useEffect(() => {

const fetchIskconFestivals = async () => {

    const currentMonth =  new Date().toLocaleString('default', { month: 'long' }); // e.g., "July"

     //const currentMonth = "January";  (to check if the API is working fine)

    // Always show current month, even if there's no data
    setMonthName(currentMonth);

  try {
    const res = await axios.get(`https://core-c343.onrender.com/api/Iskon?year=${year}`);
    console.log(res);
    const festivalsData = res.data?.months;


    setIskconFestivals(festivalsData[currentMonth] || []);
  } catch (err) {
    console.error("API error", err);
  }
};




  const fetchMonthly = async () => {
    try {
      const currentdate = new Date().toISOString().split('T')[0];
      const res = await axios.get(`https://core-c343.onrender.com/api/panchanga?date=${currentdate}`);
      setMonthly(res.data);
    } catch (error) {
      console.error('Failed to fetch Panchang data', error);
    }
  };

  fetchIskconFestivals();
  fetchMonthly();
}, []);



function convertUtcToIstTimeOnly(utcTimeStr, mode = '12') {
  if (!utcTimeStr) return 'N/A';

  const [time, modifier] = utcTimeStr.trim().split(' ');
  let [hours, minutes] = time.split(':').map(Number);

  if (modifier.toUpperCase() === 'PM' && hours !== 12) hours += 12;
  if (modifier.toUpperCase() === 'AM' && hours === 12) hours = 0;

  const today = new Date();
  const date = new Date(Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate(), hours, minutes));

  const options = {
    timeZone: 'Asia/Kolkata',
    hour: '2-digit',
    minute: '2-digit',
    hour12: mode === '12',
  };

  return date.toLocaleTimeString('en-IN', options);
}


const formatTime = (timeStr, mode = "12") => {
  if (!timeStr || typeof timeStr !== "string" || timeStr.trim() === "") return "N/A";

  const parts = timeStr.split(":").map(Number);
  const hour = parts[0];
  const minute = parts[1];
  const second = parts[2];

  // If any required part is missing, return "N/A"
  if (isNaN(hour) || isNaN(minute) || (mode === "24+" && isNaN(second))) {
    return "N/A";
  }
  

  if (mode === "12") {
    const suffix = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    return `${hour12.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")} ${suffix}`;
  }

  if (mode === "24") {
    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}`;
  }

  if (mode === "24+") {
    return `${hour.toString().padStart(2, "0")}:${minute
      .toString()
      .padStart(2, "0")}:${second.toString().padStart(2, "0")}`;
  }

  return timeStr;
};

  return (
    <div className="Iskcon-container">
      <InnerNav />

      <div className="Iskcon-content">
        <Zodiac />

        <div className="boxes">
          <div className="box1">
            <aside className="sidebar">
              <h2>{new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</h2>

      
              <div className="time">
              <button onClick={() => setTimeFormat('12')}>12 Hour</button>
              <button onClick={() => setTimeFormat('24')}>24 Hour</button>
              <button onClick={() => setTimeFormat('24+')}>24 Plus</button>
              </div>
              <div className="timings">
                <ul>
  <li><strong>Sunrise:</strong> {formatTime(monthly?.sunrise, timeFormat)}</li>
  <li><strong>Sunset:</strong> {formatTime(monthly?.sunset, timeFormat)}</li>
  <li><strong>Moonrise:</strong> {formatTime(monthly?.moonrise, timeFormat)}</li>
  <li><strong>Moonset:</strong> {formatTime(monthly?.moonset, timeFormat)}</li>
  
  <li><strong>Tithi:</strong> {monthly?.tithi?.name} ({formatTime(monthly?.tithi?.start, timeFormat)} - {formatTime(monthly?.tithi?.end, timeFormat)})</li>
  <li><strong>Paksha:</strong> {monthly?.paksha}</li>
  <li><strong>Nakshatra:</strong> {monthly?.nakshatra?.name} ({formatTime(monthly?.nakshatra?.start, timeFormat)} - {formatTime(monthly?.nakshatra?.end, timeFormat)})</li>
  <li><strong>Lunar Month:</strong> {monthly?.lunarMonth}</li>
  <li><strong>Yoga:</strong> {monthly?.yoga?.name} ({formatTime(monthly?.yoga?.start, timeFormat)} - {formatTime(monthly?.yoga?.end, timeFormat)})</li>
  
  <li><strong>Karana:</strong>
    <ul>
      {monthly?.karana?.map((k, i) => (
        <li key={i}>{k.name} – ends at {formatTime(k.end, timeFormat)}</li>
      ))}
    </ul>
  </li>

  <li><strong>Weekday:</strong> {monthly?.weekday}</li>

  <li><strong>Brahma Muhurta:</strong> {formatTime(monthly?.muhurta?.brahma?.start, timeFormat)} - {formatTime(monthly?.muhurta?.brahma?.end, timeFormat)}</li>
  <li><strong>Abhijit Muhurta:</strong> {formatTime(monthly?.muhurta?.abhijit?.start, timeFormat)} - {formatTime(monthly?.muhurta?.abhijit?.end, timeFormat)}</li>

  <li><strong>Rahu Kaal:</strong> {formatTime(monthly?.rahuKalam?.start, timeFormat)} - {formatTime(monthly?.rahuKalam?.end, timeFormat)}</li>
  <li><strong>Gulika Kaal:</strong> {formatTime(monthly?.gulikaKalam?.start, timeFormat)} - {formatTime(monthly?.gulikaKalam?.end, timeFormat)}</li>

  <li><strong>Yamaganda Kalam:</strong> {formatTime(monthly?.yamagandaKalam?.start, timeFormat)} - {formatTime(monthly?.yamagandaKalam?.end, timeFormat)}</li>
  <li><strong>Amrit Kalam:</strong> {formatTime(monthly?.amritKalam?.start, timeFormat)} - {formatTime(monthly?.amritKalam?.end, timeFormat)}</li>
  <li><strong>Varjyam:</strong> {formatTime(monthly?.varjyam?.start, timeFormat)} - {formatTime(monthly?.varjyam?.end, timeFormat)}</li>

  <li><strong>Durmuhurta:</strong>
    <ul>
      {monthly?.durMuhurtas?.map((d, i) => (
        <li key={i}>{formatTime(d.start, timeFormat)} - {formatTime(d.end, timeFormat)}</li>
      ))}
    </ul>
  </li>

  <li><strong>Bhadra:</strong> {monthly?.bhadra ? 'Yes' : 'No'}</li>
  <li><strong>Solar Eclipse:</strong> {monthly?.solarEclipse ? 'Yes' : 'No'}</li>
  <li><strong>Lunar Eclipse:</strong> {monthly?.lunarEclipse ? 'Yes' : 'No'}</li>

  {/* <li><strong>Chandra Bala:</strong> {monthly?.chandraBala?.isFavorable}</li>
  <li><strong>Birth Rashi:</strong> {monthly?.chandraBala?.birthRashi}</li> */}

  <li><strong>Amanta Month:</strong> {monthly?.amantaMonth}</li>
  <li><strong>Purnimanta Month:</strong> {monthly?.purnimantaMonth}</li>
  <li><strong>Pravishte:</strong> {monthly?.pravishte}</li>

  <li><strong>Bengali Date:</strong> {monthly?.bengaliDate?.formatted}</li>
  <li><strong>Hindu Date:</strong> {monthly?.hinduDate?.formatted}</li>

  <li><strong>Vikram Samvat:</strong> {monthly?.vikramSamvat?.formatted}</li>
  <li><strong>Shaka Samvat:</strong> {monthly?.shakaSamvatDetails?.formatted}</li>
  <li><strong>Gujarati Samvat:</strong> {monthly?.gujaratiSamvatDetails?.formatted}</li>
</ul> 
              </div>

            </aside>
          </div>

          <div className="box2">
            <div className="calendar">
              <BengaliCalendar dateType='bengali' />
            </div>
          </div>
        </div>

          <div className="festivals">
            <h2>{monthName} Vaishnav Festivals</h2>


            <div className="festival-grid">
              {iskconFestivals.length > 0 ? (
                iskconFestivals.map((festival, i) => {
                  const dateObj = new Date(festival.date);
                  const day = dateObj.toLocaleDateString('en-US', { weekday: 'long' });
                  const date = dateObj.getDate();

                  return (
                    <div key={i} className="festival-cell">
                      <div className="festival-item">
                        <p className="date">{date}</p>
                        <span className="day">{day}</span>
                      </div>
                      <div className="festival-name">
                        <p>{festival.name}</p>
                      </div>
                    </div>
                  );
                })
              ) : (
                <p>No festivals in this month</p>
              )}
            </div>
          </div>

        <IsckonCal/>
        {/* <CommentBox /> */}
        <PanchangLinks />
      </div>

      <Footer />
    </div>
  );
};

export default Iskcon;
